import { render, staticRenderFns } from "./IsciAlacakKalemiForm.vue?vue&type=template&id=535b7759"
import script from "./IsciAlacakKalemiForm.vue?vue&type=script&lang=ts"
export * from "./IsciAlacakKalemiForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports